import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ChevronDown, ChevronRight, Loader2 } from "lucide-react";
import api from "../../../lib/api";
import { markdownComponents } from "../../../pages/AdminConversations";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const ParticipantSessions = ({ participant, tool }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get(`/admin/participants/${participant.id}/tools/${tool.id}/sessions`, { params: { _: Date.now() } })
      .then((r) => { setData(r.data); if (r.data.sessions.length === 1) setOpen(r.data.sessions[0].id); })
      .catch(() => setError(true));
  }, [participant.id, tool.id]);

  if (error) return <p className="px-4 pb-4 text-sm text-red-300" data-testid="participant-sessions-error">Could not load conversations.</p>;
  if (!data) return <div className="px-4 pb-4 text-zinc-500 text-sm inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Loading conversations...</div>;

  return <div className="border-t border-zinc-900 divide-y divide-zinc-900" data-testid={`participant-sessions-${tool.id}`}>
    {data.sessions.map((s, i) => {
      const expanded = open === s.id;
      return <div key={s.id}>
        <button data-testid={`participant-session-toggle-${s.id}`} onClick={() => setOpen(expanded ? null : s.id)}
          className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-zinc-900/60 transition-colors">
          {expanded ? <ChevronDown className="w-3.5 h-3.5 text-emerald-300 shrink-0" /> : <ChevronRight className="w-3.5 h-3.5 text-zinc-500 shrink-0" />}
          <span className="text-xs text-white truncate flex-1">{i + 1}. {s.title || "Untitled"}</span>
          <span className="text-[10px] text-zinc-500 shrink-0">{s.messages.length} msgs · {fmtDate(s.updated_at)}</span>
        </button>
        {expanded && <div className="px-4 pb-4 space-y-3 bg-zinc-950/80" data-testid={`participant-session-transcript-${s.id}`}>
          {s.messages.filter((m) => m.content && (m.role === "user" || m.role === "assistant")).map((m, k) => (
            <div key={k} className={`rounded-lg px-3 py-2.5 border text-sm text-zinc-200 min-w-0 overflow-x-auto break-words ${m.role === "user" ? "border-amber-500/20 bg-amber-500/[0.04]" : "border-emerald-500/20 bg-emerald-500/[0.03]"}`}>
              <div className={`text-[10px] uppercase tracking-[0.18em] mb-1 ${m.role === "user" ? "text-amber-300/80" : "text-emerald-300/80"}`}>
                {m.role === "user" ? participant.name || "Participant" : tool.name} · {fmtDate(m.timestamp)}
              </div>
              <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>{m.content}</ReactMarkdown>
            </div>
          ))}
        </div>}
      </div>;
    })}
  </div>;
};
